import WAboutFirstBlock from './WAboutFirstBlock'

export default WAboutFirstBlock
